import { Box, useTheme } from "@mui/material";
import { BasicSwitch, TitleSubTitle } from "@platformx/utilities";
import { useTranslation } from "react-i18next";
import { useStyles } from "../Seo/Seo.styles";

const AuthorToggle = ({ state, setState }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  const isShowAuthorEnabled =
    state?.ObjectFields?.show_author ?? state?.CommonFields?.show_author ?? false;

  const handleShowAuthorChange = () => {
    setState({
      ...state,
      ObjectFields: {
        ...state.ObjectFields,
        show_author: !isShowAuthorEnabled,
      },
    });
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.width40}>
        <TitleSubTitle
          title={t("article_enable_author_title")}
          subTitle={t("article_enable_author_subtitle")}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
      </Box>
      <Box className={classes.width60}>
        <BasicSwitch
          onChange={handleShowAuthorChange}
          checked={isShowAuthorEnabled}
          // disabled={isDisable}
          color={theme.palette.customColor.PRIMARY}
        />
      </Box>
    </Box>
  );
};

export default AuthorToggle;
